import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';

@Component({
    selector: 'tt-powtimes-grid',
    templateUrl: './powtimes-grid.component.html',
    styleUrls: ['./powtimes-grid.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class PowtimesGridComponent implements OnChanges {
    grid?: GridOptions;

    @Input()
    rememberId: string = '';

    @Input()
    params?: PowtimesGridParams;

    @Output()
    gridReady = new EventEmitter<GridOptions>();

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.rememberId).setLoadDataFunction({ method: 2127, parameters: () => this.params });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']?.currentValue) {
            this.readGrid();
        }
    }
}

export interface PowtimesGridParams {
    argtype?: string;
    argvalue?: boolean | number | string;
    businessco_no?: `${number}` | number;
    order_internal_no?: string | number;
    cust_name?: string;
    cust_no?: string;
    custact_no?: string | number;
    date_fom?: string;
    date_fomtom?: string;
    date_tom?: string;
    dateselector_index?: `${number}`;
    labour_no?: `${number}`;
    project_keyno?: `${number}`;
    project_name?: string;
    show_setting?: '1' | '0';
    view_id?: string;
    webpage_name?: string;
}
